import { useNavigate } from 'react-router-dom';
import FryLogList from '../../components/admin/FryLogList.jsx';
import Inventory from '../../components/admin/Inventory.jsx';
import { Link } from 'react-router-dom';
import OrdersTable from '../../components/admin/OrdersTable.jsx';

export default function AdminDashboard() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/admin/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (err) {
      console.error('Logout failed', err);
    } finally {
      navigate('/admin');
    }
  };

  return (
    <div className="min-h-screen bg-pink-50 dark:bg-gray-900 text-gray-800 dark:text-gray-100 p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">🍩 Admin Dashboard</h1>
        <button
          onClick={handleLogout}
          className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded shadow"
        >
          Log Out
        </button>
      </div>

      <div className="mb-4">
        <Link
          to="/admin/dashboard/new"
          className="inline-block bg-pink-500 hover:bg-pink-600 text-white font-medium px-4 py-2 rounded"
        >
          + New Fry Session
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <FryLogList />
        <Inventory />
      </div>

      <OrdersTable />
    </div>
  );
}
